import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { Subject } from '@chancenwerk/enums/enums.js';
import { html } from 'lit';

@Entity()
export class PreferredSubjectAspect extends AbstractAspect {
  static override _class = 'PreferredSubjectAspect';

  constructor(doc: PartialEntityData<PreferredSubjectAspect>) {
    const newDoc = {
      fieldName: 'preferedFirstSubject',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => [String]) value: Maybe<Subject[]>;

  override getMongoFilter(): object | null {
    if (!this.value?.length || !this.fieldName) return null;

    return {
      $or: [
        {
          preferedFirstSubject: {
            $in: this.value,
          },
        },
        {
          preferedSecondSubject: {
            $in: this.value,
          },
        },
        {
          preferedThirdSubject: {
            $in: this.value,
          },
        },
      ],
    };
  }
}

export const PreferredSubjectAspectSchema: AspectConfig<PreferredSubjectAspect> = {
  aspectConstructor: PreferredSubjectAspect,
  renderEditor: ({ aspectValue }) => html`
    <cr-dropdown-selection
      placeholder="Wunschfach"
      placeholder-mode="hide"
      .selectables=${Object.values(Subject)}
      @value-picked=${(e: ValueEvent<Maybe<Subject>>) => {
        aspectValue.value = e.detail.value ? [e.detail.value] : null;
      }}
      .valueID=${aspectValue.value?.[0]}
    ></cr-dropdown-selection>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
